import { render, staticRenderFns } from "./StepLink.vue?vue&type=template&id=4a921179&scoped=true"
import script from "./StepLink.vue?vue&type=script&lang=js"
export * from "./StepLink.vue?vue&type=script&lang=js"
import style0 from "./StepLink.vue?vue&type=style&index=0&id=4a921179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a921179",
  null
  
)

export default component.exports